import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { checkMechanicHasPricingDoneOrders } from "../../../services/order";
import { APP_PATHS } from "../../../constants/paths";
import pricedOrdersArrow from "../../../assets/icons/home_notify_arrow.svg";
import pricedOrdersIcon from "../../../assets/icons/priced_orders_notify_icon.svg";
import pricedMtorVector from "../../../assets/icons/priced_orders_mtor_vector.svg";
import classes from "./PricedOrdersSection.module.css";

const PricedOrdersSection = () => {
  const [hasPricedOrders, setHasPricedOrders] = useState(false);

  useEffect(() => {
    const checkPricedDoneOrders = async () => {
      try {
        const response = await checkMechanicHasPricingDoneOrders();
        const {
          data: { status },
        } = response;
        setHasPricedOrders(status);
      } catch (err) {
        console.error(err);
      }
    };

    checkPricedDoneOrders();
  }, []);

  if (!hasPricedOrders) return null;

  return (
    <Link
      to={APP_PATHS.PRICED_ORDERS.url}
      className={classes["priced-orders-link"]}
    >
      <p className={classes["priced-orders-link__text"]}>لقد تم تسعير طلباتك</p>
      <img
        src={pricedOrdersArrow}
        alt="arrow"
        className={classes["priced-orders-link__arrow-icon"]}
      />
      <img
        src={pricedOrdersIcon}
        alt="priced orders"
        className={classes["priced-orders-link__priced-icon"]}
      />
      <img
        src={pricedMtorVector}
        alt="mtor"
        className={classes["priced-orders-link__mtor-vector"]}
      />
    </Link>
  );
};

export default PricedOrdersSection;
